module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span8"
  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.label) + ":")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text2),
      expression: "text2"
    }],
    staticClass: "input-xxlarge",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.text2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text2 = $event.target.value
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63c5794c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Content/Modern/js/vue/_block-text.vue
// module id = 117
// module chunks = 1